import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthleteGLMLinkStatus, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

import { athleteGLMStatusKey } from './useAthleteGLMStatus';

/**
 * Create a brand-new GLM contact for an athlete and link it. On success invalidates
 * the athlete detail + athlete list + GLM status caches.
 */
export default function useCreateAthleteGLMContact(): UseMutationResult<
  AxiosResponse<AthleteGLMLinkStatus>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  return useMutation(
    (athleteId: string) => client.post<AthleteGLMLinkStatus>(`athletes/${athleteId}/glm/create-contact/`),
    {
      onSuccess: (_data, athleteId) => {
        queryClient.invalidateQueries(athleteGLMStatusKey(athleteId));
        queryClient.invalidateQueries('athletes');
      },
    },
  );
}
